import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { ToasterService } from './toaster.service';
import { Observable } from 'rxjs';
import { concatMap, map, take } from 'rxjs/operators';
import {
  ActionsEnum,
  ClearToast,
  ShowToast,
  UpdateToasterData,
  updateToasterData,
} from './toaster.actions';
import { GLOBAL_CONTAINER_ID, IToasterConfig } from './toaster.data';
import { ToasterStore } from './toaster.store';
import { noop } from 'lodash';

@Injectable()
export class ToasterEffects {
  private _globalContainerOptions = {
    toastContainerId: GLOBAL_CONTAINER_ID,
  } as IToasterConfig;

  constructor(
    private _actions: Actions,
    private _toasterService: ToasterService,
    private _toasterStore: ToasterStore
  ) {}

  @Effect()
  showToast: Observable<UpdateToasterData> = this._actions.pipe(
    ofType(ActionsEnum.SHOW_TOAST),
    map(({ payload }: ShowToast) => {
      const { toastConfig } = payload;
      const mergedToastConfig = {
        ...this._globalContainerOptions,
        ...toastConfig,
      };
      const toastInstance = this._toasterService.notify(
        mergedToastConfig.type,
        mergedToastConfig.component,
        mergedToastConfig.toastContainerId,
        mergedToastConfig.onShow,
        mergedToastConfig.onDismiss
      );
      const standardOptions = {
        toastId: toastInstance.toastId,
        onPrimaryAction: mergedToastConfig.onPrimaryAction || noop,
        onDismiss: mergedToastConfig.onDismiss || noop,
      };
      const newToasterData = {
        ...mergedToastConfig.data,
        ...standardOptions,
      };

      return updateToasterData(newToasterData);
    })
  );

  @Effect()
  clearToast: Observable<UpdateToasterData> = this._actions.pipe(
    ofType(ActionsEnum.CLEAR_TOAST),
    concatMap(({ payload }: ClearToast) => {
      return this._toasterStore.getToasterData().pipe(
        take(1),
        map((toasterData) => {
          if (toasterData) {
            const { toastId, toastContainerId } = payload;

            this._toasterService.clear(toastId, toastContainerId);
          }

          return updateToasterData(null);
        })
      );
    })
  );
}
